export default __webpack_public_path__ + "static/media/cover-10.90e997e8.webp";